import React from 'react';
import styles from './Modal.module.scss';

const ModalFooter = ({ children }) => (
  <div className={styles.footer}>{children}</div>
);

export default ModalFooter;
